/**
 * Display helpers shared by the matter tab, the dashboard and the letter page.
 * Kept free of '@/utils' so the guards next to it stay unit-testable.
 */

export const STATUS_LABELS = {
  draft: 'Draft',
  pending_approval: 'Awaiting approval',
  approved: 'Approved',
  sent: 'Sent',
  responded: 'Responded',
  void: 'Void',
};

export const STATUS_BADGE = {
  draft: 'badge-warning',
  pending_approval: 'badge-info',
  approved: 'badge-primary',
  sent: 'badge-success',
  responded: 'badge-dark',
  void: 'badge-danger',
};

export const CHANNELS = [
  { value: 'email', label: 'Email (sent from the app, PDF attached)' },
  { value: 'certified_mail', label: 'U.S. Certified Mail, return receipt' },
  { value: 'regular_mail', label: 'Regular mail' },
  { value: 'fax', label: 'Fax' },
];

export const CHANNEL_SHORT = {
  email: 'Email',
  certified_mail: 'Certified mail',
  regular_mail: 'Mail',
  fax: 'Fax',
};

export const RESPONSE_LABELS = {
  accepted: 'Accepted',
  rejected: 'Rejected',
  countered: 'Countered',
  no_response: 'No response',
};

export const NEGOTIATION_KINDS = [
  { value: 'offer', label: 'Offer from the insurer' },
  { value: 'counter', label: 'Counter' },
  { value: 'acceptance', label: 'Acceptance' },
  { value: 'rejection', label: 'Rejection' },
  { value: 'note', label: 'Note / call log' },
];

export const EVENT_LABELS = {
  generated: 'Generated',
  regenerated: 'Regenerated from template',
  approval_requested: 'Approval requested',
  approved: 'Approved',
  approval_rejected: 'Returned for changes',
  approval_revoked: 'Approval withdrawn (letter changed)',
  sent: 'Sent',
  filed: 'PDF filed under the matter',
  filing_failed: 'PDF could not be filed (storage)',
  email_delivered: 'Email delivered',
  email_opened: 'Email opened',
  email_bounced: 'Email bounced',
  email_dropped: 'Email dropped',
  email_deferred: 'Email deferred',
  esign_sent: 'Sent for e-signature',
  esign_partially_signed: 'Partially signed',
  esign_signed: 'Signed by all signers',
  negotiation_recorded: 'Negotiation entry',
  revised: 'Revision created',
  voided: 'Voided',
};

export const statusBadge = (status) =>
  `<span class="badge badge-pill badge-outline ${STATUS_BADGE[status] || 'badge-light'}">${STATUS_LABELS[status] || status || '-'}</span>`;

export const money = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const number = Number(value);
  if (Number.isNaN(number)) return String(value);
  return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};
